import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-date-time-picker',
  templateUrl:
    'console/app-js/shared/components/date-time-picker/date-time-picker.component.html'
})
export class DateTimePickerComponent implements OnInit {
  @Input() mode: String = 'date';
  @Input() value: Date;
  @Input() timezone: String;
  @Input() min: Date;
  @Input() max: Date;
  @Input() placeholder: String;
  @Input() error: Boolean = false;
  @Output() valueUpdated = new EventEmitter();

  constructor() {}

  ngOnInit() {
    const placeholder = this.mode === 'date' ? 'Set Day…' : 'Set Time…';
    this.placeholder = this.placeholder || placeholder;
    this.value = new Date();
  }

  valueChanged = ($event: any) => {
    this.valueUpdated.emit($event);
  };
}
